import { forwardRef } from 'react';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority'

const buttonVariants = cva('btn', {
	variants: {
		variant: {
			classic: 'btn--text',
			primary: 'btn--primary',
			primaryOutline: 'btn--primary-outline',
			icon: 'btn--icon'
		},
		shape: {
			capsule: 'btn--capsule',
			round: 'btn--round'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export interface ButtonProps 
	extends React.ComponentPropsWithRef<'button'>, VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<
	HTMLButtonElement,
	ButtonProps
>(function Button(
	{ 
		className, 
		variant, 
		shape,
		children,
		...buttonProps
	}, 
	ref
) {
	return (
		<button 
			ref={ref}
			className={buttonVariants({ variant, shape, className })}
			{...buttonProps}
		>
			{children}
		</button>
	);
});